import { render, staticRenderFns } from "./grant.vue?vue&type=template&id=1768797f&scoped=true"
import script from "./grant.vue?vue&type=script&lang=ts"
export * from "./grant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1768797f",
  null
  
)

export default component.exports